import { defineStore } from 'pinia'
import { ref, computed } from 'vue'
import { useForm } from 'vee-validate'
import type { Maybe, Transaction } from '@/types'
import { PayerType, PaymentMethod, PaymentType } from '@/types'

const useTransactionDataStore = defineStore(
  'transactionData',
  () => {
    // @ToDo
    // 1. think about adding BrandType for zł/gr

    const methodType = ref<PaymentMethod>(PaymentMethod.online)
    const paymentType = ref<PaymentType>(PaymentType.purchase)

    const amount = ref<number | null>(null)
    const getSelectedOrOtherAmount = computed<Maybe<number>>(
      () => Number(transactionData.value?.otherAmount) || amount.value
    )

    const transactionData = ref<Transaction>()
    // We need to wrap useForm in a function to have fully control when to call useForm
    // From Vee-Validate:
    // Using useForm inside Pinia stores may cause unwanted behavior
    // as lifecycle hooks only execute against the component that first initialized the store.
    const initUseForm = () => {
      const { values, handleSubmit, errors } = useForm<Transaction>({
        initialValues: {
          payerType: PayerType.person,
          ...transactionData.value,
          consents: {}
        },
        keepValuesOnUnmount: true
      })

      transactionData.value = values
      return { handleSubmit, errors }
    }

    return {
      transactionData,
      methodType,
      paymentType,
      amount,
      getSelectedOrOtherAmount,
      initUseForm
    }
  },
  {
    persist: {
      storage: sessionStorage,
      pick: [
        'transactionData.donor',
        'transactionData.address',
        'transactionData.payerType',
        'transactionData.companyName',
        'transactionData.anonymous',
        'transactionData.nipNumber'
      ],
      afterHydrate: (ctx) => {
        ctx.store.initUseForm()
      }
    }
  }
)

export default useTransactionDataStore
